<p-tabView (onChange)="onTabChange($event)">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
    <div>
      <p-dropdown 
        styleClass="ml-2 fieldFilterControl" 
        [options]="listeService.opzioniRegioneProntofibra"
        optionLabel="label"
        optionValue="value"
        (onChange)="filtraPerRegione($event.value)"
        placeholder="Regione"
        [showClear]="false"
        [filter]="false"
        [(ngModel)]="filtroRegione"
      />
      <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
        style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
        pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
      ></button>
    </div>
    
     <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
      <span 
        class="text-right font-['Poppins']" 
        style="color: #191a1b; font-size: medium; font-weight: 600;"  
      >{{labelRegioni}}</span>
    </div>
   <!-- [(ngModel)]="filtroPratiche.tipo"  (onChange)="filtraPratiche($event)" -->
    <button 
    pButton type="button" icon="pi pi-cloud-download"
    pTooltip="Esporta i dati" tooltipPosition="top"
    class="font-['Poppins']"
    style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
    (click)="scaricaReportSopralluoghi()" 
  ></button>
  </div>
  <p-tabPanel header="Bando 1">
    <div>
      <p-table styleClass="p-datatable-sm" 
        [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
        [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiBando1Filtrati" dataKey="impresa" [(selection)]="selectedPraticaBando1KO">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%;">IMPRESA</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">NO SOPRALLUOGO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">NO SOPRALLUOGO (PF)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO PIANIFICATO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO KO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO ESEGUITO</th>

<!--               <i class="pi pi-info-circle ml-1 cursor-pointer" pTooltip="Comprende i sopralluoghi con esito positivo e quelli KO" tooltipPosition="top"></i>
 -->            
            <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;">TOTALE</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <p-tag [value]="row.impresa | uppercase"
                [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer'
                }"
                 (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" tooltipPosition="top">
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noSopralluogo"
              [style]="{
                'background-color': '#BFC0C0',
                'color': '#ffffff',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '12px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noSopralluogo > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa, 'noSopralluogo')"
               [pTooltip]="!isPresidioTIM && row.noSopralluogo > 0 ?'Apri le pratiche SENZA SOPRALLUOGO di ' + row.impresa:null" tooltipPosition="top"
              ></p-tag>
             <!--  <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 12px;" 
            >
                {{row.noSopralluogo}}
              </span> -->
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noSopralluogoPF"
              [style]="{
                'background-color': '#7C90A0',
                'color': '#ffffff',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '12px',
                'letter-spacing': '.3px;',
                'cursor':   !isPresidioTIM && row.noSopralluogoPF > 0 ? 'pointer': 'default'
              }"
               (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'noSopralluogoPF')"
               [pTooltip]=" !isPresidioTIM && row.noSopralluogoPF > 0 ? 'Apri le pratiche SENZA SOPRALLUOGO (PF) di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
             
            <!--   <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 12px;">
                {{row.noSopralluogoPF}}
              </span> -->
            </td>
            <td class="text-center font-['Poppins']">
                <p-tag [value]="row.sopralluogoPianificato"
                  [style]="{
                    'background-color': '#58A4B0',
                    'color': '#ffffff',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '12px',
                    'letter-spacing': '.3px;',
                    'cursor':  !isPresidioTIM &&  row.sopralluogoPianificato > 0 ? 'pointer': 'default'
                  }"
                  (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoPianificato')"
                  [pTooltip]=" !isPresidioTIM && row.sopralluogoPianificato > 0 ? 'Apri le pratiche CON SOPRALLUOGO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
             <!--  <span class="text-uppercase font-semibold font-['Poppins']" style="font-size: 12px;">
                {{row.sopralluogoPianificato}}
              </span> -->
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.sopralluogoKO"
                [style]="{
                  'background-color': '#F75C03',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor':   !isPresidioTIM && row.sopralluogoKO > 0 ? 'pointer': 'default'
                }"
                 (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoKO')"
                 [pTooltip]=" !isPresidioTIM && row.sopralluogoKO > 0 ? 'Apri le pratiche CON SOPRALLUOGO KO di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.sopralluogoEseguito"
                [style]="{
                  'background-color': '#04A777',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor':  !isPresidioTIM &&  row.sopralluogoEseguito > 0 ? 'pointer': 'default'
                }"
                (click)="openPraticheFase1DiImpresa(1,row.idImpresa,row.impresa,'sopralluogoEseguito')"
                [pTooltip]=" !isPresidioTIM && row.sopralluogoEseguito > 0 ? 'Apri le pratiche CON SOPRALLUOGO ESEGUITO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
            </td>
            
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.totale"
                [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliNoSopralluogoBando1"
                [style]="{
                  'background-color': '#BFC0C0',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
             <!--  {{totaliNoSopralluogoBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliNoSopralluogoPFBando1"
                [style]="{
                  'background-color': '#7C90A0',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
             <!--  {{totaliNoSopralluogoPFBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliSopralluogoPianificatoBando1"
                [style]="{
                  'background-color': '#58A4B0',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliSopralluogoKOBando1"
                [style]="{
                  'background-color': '#F75C03',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag [value]="totaliSopralluogoEseguitoBando1"
                  [style]="{
                    'background-color': '#04A777',
                    'color': '#191a1b',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px;',
                  }"
                  >
              </p-tag>
            </td>
           
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliNoSopralluogoBando1 + totaliNoSopralluogoPFBando1 + totaliSopralluogoPianificatoBando1 + totaliSopralluogoEseguitoBando1 + totaliSopralluogoKOBando1"
                [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
              <!-- {{totaliNoSopralluogoBando1 + totaliNoSopralluogoPFBando1 + totaliSopralluogoPianificatoBando1 + totaliSopralluogoEseguitoBando1}} -->
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Bando 2">
    <div>
      <p-table styleClass="p-datatable-sm" 
        [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
        [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiBando2Filtrati" dataKey="impresa" [(selection)]="selectedPraticaBando2KO">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%;">IMPRESA</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">NO SOPRALLUOGO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">NO SOPRALLUOGO (PF)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO PIANIFICATO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO KO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;">SOPRALLUOGO ESEGUITO</th>

            <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;">TOTALE</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <p-tag [value]="row.impresa | uppercase"
                [style]="{
                  'background-color': '#6495ed',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer'
                }"
                 (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                  [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                tooltipPosition="top">
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noSopralluogo"
              [style]="{
                'background-color': '#BFC0C0',
                'color': '#ffffff',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '12px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noSopralluogo > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa, 'noSopralluogo')"
               [pTooltip]="!isPresidioTIM && row.noSopralluogo > 0 ?'Apri le pratiche SENZA SOPRALLUOGO di ' + row.impresa:null" tooltipPosition="top"
              ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noSopralluogoPF"
              [style]="{
                'background-color': '#7C90A0',
                'color': '#ffffff',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '12px',
                'letter-spacing': '.3px;',
                'cursor':  !isPresidioTIM &&  row.noSopralluogoPF > 0 ? 'pointer': 'default'
              }"
               (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'noSopralluogoPF')"
               [pTooltip]=" !isPresidioTIM && row.noSopralluogoPF > 0 ? 'Apri le pratiche SENZA SOPRALLUOGO (PF) di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.sopralluogoPianificato"
              [style]="{
                'background-color': '#58A4B0',
                'color': '#ffffff',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '12px',
                'letter-spacing': '.3px;',
                'cursor':  !isPresidioTIM &&  row.sopralluogoPianificato > 0 ? 'pointer': 'default'
              }"
              (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoPianificato')"
              [pTooltip]=" !isPresidioTIM && row.sopralluogoPianificato > 0 ? 'Apri le pratiche CON SOPRALLUOGO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.sopralluogoKO"
                [style]="{
                  'background-color': '#F75C03',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor':  !isPresidioTIM &&  row.sopralluogoKO > 0 ? 'pointer': 'default'
                }"
                 (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoKO')"
                 [pTooltip]=" !isPresidioTIM && row.sopralluogoKO > 0 ? 'Apri le pratiche CON SOPRALLUOGO KO di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.sopralluogoEseguito"
                [style]="{
                  'background-color': '#04A777',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                  'cursor':  !isPresidioTIM &&  row.sopralluogoEseguito > 0 ? 'pointer': 'default'
                }"
                (click)="openPraticheFase1DiImpresa(2,row.idImpresa,row.impresa,'sopralluogoEseguito')"
                [pTooltip]=" !isPresidioTIM && row.sopralluogoEseguito > 0 ? 'Apri le pratiche CON SOPRALLUOGO ESEGUITO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
            </td>
           
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.totale"
                [style]="{
                  'background-color': '#6495ed',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '12px',
                  'letter-spacing': '.3px;',
                }"
               >
              </p-tag>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliNoSopralluogoBando2"
              [style]="{
                 'background-color': '#BFC0C0',
                 'color': '#191a1b',
                'border-radius': '6px',
                'padding': '.25em .5rem',
                'font-weight': '800',
                'font-size': '13px',
                'letter-spacing': '.3px;',
              }"
              >
          </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag [value]="totaliNoSopralluogoPFBando2"
                  [style]="{
                      'background-color': '#7C90A0',
                      'color': '#191a1b',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px;',
                  }"
                  >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
                <p-tag [value]="totaliSopralluogoPianificatoBando2"
                  [style]="{
                    'background-color': '#58A4B0',
                    'color': '#191a1b',
                    'border-radius': '6px',
                    'padding': '.25em .5rem',
                    'font-weight': '800',
                    'font-size': '13px',
                    'letter-spacing': '.3px;',
                  }"
                  >
              </p-tag>
              
            </td>
           
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliSopralluogoKOBando2"
                [style]="{
                   'background-color': '#F75C03',
                   'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliSopralluogoEseguitoBando2"
                [style]="{
                  'background-color': '#04A777',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliNoSopralluogoBando2 + totaliNoSopralluogoPFBando2 + totaliSopralluogoPianificatoBando2 + totaliSopralluogoEseguitoBando2 +totaliSopralluogoKOBando2"
                [style]="{
                  'background-color': '#6495ed',
                  'color': '#191a1b',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-tabPanel>
</p-tabView>
